<template>
  <v-overlay
    :value="getPopupStatusFromStorage"
    z-index="1000"
  >
   <v-alert
     class="ma-4 popup-alert"
     data-testid="alert-popup"
     v-model="getPopupStatusFromStorage"
     :type="getPopupTypeFromStorage"
     dismissible
     v-if="getPopupStatusFromStorage"
   >
     <div v-if="getPopupTitleFromStorage" class="font-weight-bold mb-2">{{ getPopupTitleFromStorage }}</div>
     <div>{{ getPopupMessageFromStorage }}</div>
     <template v-slot:close="{ toggle }">
       <v-icon @click="closePopup">mdi-close-circle-outline</v-icon>
     </template>
   </v-alert>
  </v-overlay>
</template>

<script>
import store from '../store';

export default {
  name: 'Popup',
  methods: {
    closePopup() {
      store.commit('closeAlertPopup');
    },
  },
  computed: {
    getPopupStatusFromStorage() {
      return store.state.popupAlertStatus;
    },
    getPopupTitleFromStorage() {
      return store.state.popupAlertTitle;
    },
    getPopupMessageFromStorage() {
      return store.state.popupAlertMessage;
    },
    getPopupTypeFromStorage() {
      return store.state.popupAlertType;
    },
  },
};
</script>

<style scoped>
.popup-alert {
  width: calc(100vw - 32px);
  max-width: 500px;
  min-width: 0;
}
</style>
